module.exports = __webpack_public_path__ + "d2fad60353b26ed4994aae464d2ca91c.jpg";